import { apiRequest } from './http-client';
import type { PayorRow, VobWebformPayor } from './types';
import { AVAILITY_VOB_SOURCE_SLUG } from './vob-source';

const PAYOR_PAGE_SIZE = 1000;

export async function fetchPayorList(
  apiBase: string,
  authToken: string
): Promise<PayorRow[]> {
  const payors: PayorRow[] = [];
  let offset = 0;

  while (true) {
    const response = await apiRequest<PayorRow[]>(
      apiBase,
      `/configuration/v2/configuration/payor?offset=${offset}&limit=${PAYOR_PAGE_SIZE}&vobSource=${encodeURIComponent(AVAILITY_VOB_SOURCE_SLUG)}`,
      { authToken }
    );

    if (response.hasErrors) {
      throw new Error(response.errorMessage ?? 'Failed to load payor list');
    }

    const page = response.entity ?? [];
    payors.push(...page);

    if (page.length < PAYOR_PAGE_SIZE) {
      break;
    }
    offset += PAYOR_PAGE_SIZE;
  }

  return payors;
}

export function mapPayorsToWebformPayors(payors: PayorRow[]): VobWebformPayor[] {
  return payors
    .filter((payor) => payor.payorName?.trim())
    .map((payor) => ({
      payorName: payor.payorName,
      payorId: String(payor.payorId),
      payorPlanId: payor.payorPlans?.[0]?.payorPlanId,
    }))
    .sort((a, b) => a.payorName.localeCompare(b.payorName));
}
